export default {
  contentMarginTop: {
    mobile: '1.5rem',
    desktop: '2.5rem',
  },
};
